import { HttpInterceptor } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const CACHE_HTTP_INTERCEPTORS = new InjectionToken<HttpInterceptor[]>(
  'An abstraction on cache HttpInterceptor[]'
);
